exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog{\n    width: 500px;\n}\n\n.inmodal .modal-title {\n    font-size: 18px;\n}\n\n\n.text{\n    color: #fff;\n    text-align: center;\n    padding-top: 20px;\n    font-size: 14px;\n    font-weight: normal;\n}\n\n\n@media (max-width: 767px) {\n    .modal-dialog{\n        width: 100%;\n    }   \n    .modal-body {\n        padding: 17px 30px 10px 30px;\n    }\n    .inmodal .modal-header {\n        padding: 20px 15px;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/global/navigation.component.css
// module id = ../../../../../src/app/global/navigation.component.css
// module chunks = main